import React from "react";
import image1 from '../../../assets/images/whiky_house/4 worth trying.png'
import image2 from '../../../assets/images/whiky_house/2 Aberlour 12 Yrs.png'
import image3 from '../../../assets/images/whiky_house/3 Macallan 18 yrs.png'
const Images = () => {
  return (
    <div
      id="lookbook"
      className="grid md:grid-cols-3 grid-cols-1 gap-4 px-2 md:px-4 lg:px-10 mt-10"
    >
      <div className="md:col-span-3  relative w-full">
        <img
          src={image2}
          className="h-[21.3rem]  object-center object-cover w-full"
          alt=""
        />
        <div className="absolute top-0 right-0 text-end ">
          <h1 className="text-4xl text-white font-['Open_Sans'] max-w-sm px-8 pt-8 font-bold ">
            Our Favorite
          </h1>
        </div>
      </div>
      {/* <div className=" col-span-1 relative ">
        <img
          src="https://secretbottleshop.co.uk/cdn/shop/files/Basil-Hayden-Bourbon-Lifestyle-1_786x786.png?v=1685031048"
          className="h-[21.3rem]  object-center object-cover w-full"
          alt=""
        />
        <div className="absolute top-0 right-0 text-end ">
          <h1 className="text-4xl text-white font-['Open_Sans'] max-w-sm px-8 pt-8 font-bold ">
            Discover Basil Hayden
          </h1>
        </div>
      </div> */}
      <div className=" md:col-span-1 relative ">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FNo.3%20Update%20.jpg?alt=media&token=17fa8239-52da-401e-b8d2-eb2c2d0ab3b8"
          className="h-[21.3rem] object-center object-cover w-full"
          alt=""
        />
        <div className="absolute top-0 right-0 text-end ">
          <h1 className="text-4xl text-white font-['Open_Sans'] max-w-sm px-8 pt-8 font-bold ">
            The Perfect Gift
          </h1>
        </div>
      </div>
      <div className="md:col-span-2  relative ">
        <div>
          <img
            src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FNo.4%20Update%20%20(1).jpg?alt=media&token=f60e2376-0cd2-4ffb-830d-6bbdb4eb9126"
            className="h-[21.3rem] object-cover  w-full"
            alt=""
          />

          <div className="absolute top-0 right-0 text-end ">
            <h1 className="text-4xl text-white font-['Open_Sans'] max-w-sm px-8 pt-8 font-bold ">
              Worth Trying Selection
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Images;
